/** @jsx jsx */
import { jsx } from "theme-ui";
import * as React from "react";
import PropTypes from "prop-types";
// import Footer from "../SiteFooter";
import useAuth from "gatsby-plugin-hfn-profile/auth/useAuth";
import {
  DefaultButton,
  MessageBar,
  MessageBarType,
} from "office-ui-fabric-react";
import { useCallback } from "react";
import { buttonStyles } from "sites-common/utils/fabricStyles";
import { useDispatch, useSelector } from "react-redux";
import Header from "../SiteHeader";
import { selectorBehaveAs } from "../../state/appSelectors";
import { resetBehaveAs } from "../../state/appActions";
import Auth from "../Auth";

const Layout = ({ children }) => {
  const behave_as = useSelector(selectorBehaveAs);
  const dispatch = useDispatch();

  const { srcmProfile } = useAuth();

  const StopBehaveAs = useCallback(() => dispatch(resetBehaveAs()), [dispatch]);

  const who_am_i = srcmProfile?.email;
  return (
    <React.Fragment>
      <Auth />
      {!!behave_as && behave_as !== who_am_i && (
        <MessageBar messageBarType={MessageBarType.severeWarning}>
          Admin {who_am_i} behaving as {behave_as}
          <br />
          <DefaultButton
            styles={buttonStyles.blueLight}
            text="Stop Emulation"
            onClick={StopBehaveAs}
          />
        </MessageBar>
      )}
      <div
        sx={{
          height: "100vh",
          backgroundColor: "#ffffff",
          "@media (max-width: 480px)": {
            height: "auto",
          },
        }}
      >
        <Header />
        <div
          sx={{
            width: "98%",
            margin: "14px auto 0 auto",
          }}
        >
          <main>{children}</main>
        </div>
        {/* <Footer /> */}
      </div>
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
